<template>
  <div class="body">
    <announcement/>
    <balanceWithdraw></balanceWithdraw>
    <div class="clerk" v-if="hasRole('clerk')">
      <div class="clerk-head">
        <div style="position: relative;display: flex;align-items: center;">
          <div class="clerk-img">
            <img :src="this.clerk.avatarUrl">
          </div>
          <div class="clerk-other">
            <div class="box1">
              <div class="name">{{this.clerk.name}}</div>
              <img class="grade" :src="'/static/images/196/' + (this.clerk.grade) + '.png'">
            </div>
            <div class="sex-age">
              <img :src="'/static/images/196/' + (clerk.sex == $store.state.ClerkSexEnum.MEN.value? 'sex1' : 'sex2') + '.png'"
                   style="height: 10px; margin-right: 3px">
              <span>{{ clerk.age }}</span>
            </div>
          </div>

          <div style="font-size: 10px; position: absolute; right: 0; color: #333; display: flex; flex-direction: column; align-items: flex-end;">
            <div style="display: flex; align-items: center; margin-bottom: 8px">
              <span style="white-space: nowrap" v-if="clerk.status == 1">在线</span>
              <span style="white-space: nowrap" v-else-if="clerk.status == 2">离线</span>
              <img style="height: 16px; margin-left: 7px" @click="clerk.status = (clerk.status == 1 ? '2' : '1');updateStatus(clerk.status,'clerk')" :src="'/static/images/196/' + (clerk.status == 1 ? 'on' : 'off') + '.png'">
            </div>
            <div style="display: flex; align-items: center" v-if="$ClerkPermission.modifiableClerkAttr.includes('randomOrderSwitch')">
              <span style="white-space: nowrap">随机单</span>
              <img style="height: 16px; margin-left: 7px" @click="clerk.randomOrderSwitch = !clerk.randomOrderSwitch;updateRandomOrderSwitch(clerk.randomOrderSwitch)" :src="'/static/images/196/' + (clerk.randomOrderSwitch ? 'on' : 'off') + '.png'">
            </div>
          </div>
        </div>

        <div class="box2">
<!--          <div class="switch-style" v-if="$hasFeature('auto_online')">-->
<!--            <span v-if="clerkIsAutoOnline">自动在线</span>-->
<!--            <span v-else-if="!clerkIsAutoOnline">手动在线</span>-->
<!--            <img @click="clerkIsAutoOnline = !clerkIsAutoOnline;updateClerkIsAutoOnline(clerkIsAutoOnline)" :src="'/static/images/125/' + (clerkIsAutoOnline ? 'on' : 'off') + '.png'">-->
<!--          </div>-->

          <div class="switch-style" v-for="(switchItem, index) of itemSwitchList" :key="index">
            <img @click="updateItemSwitch(switchItem.id)" :src="'/static/images/196/' + (clerkItemSwitchIds.indexOf(switchItem.id) != -1 ? 'on' : 'off') + '.png'">
            <span>{{ switchItem.name }}</span>
          </div>
        </div>

        <router-link v-if="$ClerkAccess.includes('wages')" to="/clerk/wages">
          <div class="profit">
            <div class="title">
              <span>本周预计收益(元)</span>
            </div>
            <div class="profit-body">
              <div class="box-left">
                <span class="money">{{ statistics.thisWeek / 100}}</span>
                <span>上周收益 : {{ statistics.lastWeek / 100}}</span>
              </div>
              <div class="box-right">每周三24:00前发放</div>
            </div>
            <img src="/static/images/196/xx.png" class="xx-icon">
          </div>
        </router-link>

      </div>


      <div class="title-t">
        <div class="biaoti" @click="clerkShow = !clerkShow">
          <span>店员</span>
          <van-icon :name="clerkShow ? 'arrow-down' : 'arrow-up'" style="font-weight: bold;margin-left: 5px" />
        </div>
      </div>
      <div class="body-t" v-show="clerkShow">
        <router-link v-if="$ClerkAccess.includes('manual')" to="/article/list?type=2">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon1.png">
              </div>
              <span>店员手册</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('order')" to="/clerk/order/list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon2.png">
              </div>
              <span>订单</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('random')" to="/clerk/random">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon3.png">
              </div>
              <span>抢单大厅</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('wages')" to="/clerk/wages">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon4.png">
              </div>
              <span>工资</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="($hasFeature('clerk_ranking') || $store.state.shop.version === 'combination') && $ClerkAccess.includes('ranking-list')" to="/clerk/ranking-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon5.png">
              </div>
              <span>排名</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('info')" to="/clerk/info">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon7.png">
              </div>
              <span>我的资料</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('grade')" to="/clerk/grade">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon8.png" style="height: 70%">
              </div>
              <span>我的等级</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('reward-log')" to="/clerk/reward-log">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon9.png">
              </div>
              <span>打赏动态</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasFeature('post_list') && $ClerkAccess.includes('post-list')" to="/clerk/post/list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon10.png">
              </div>
              <span>发布动态</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$ClerkAccess.includes('my-performance')" to="/clerk/performance">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon15.png">
              </div>
              <span>我的业绩</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <img src="/static/images/196/sku-love.png" class="sku-love1">
        <img src="/static/images/196/yun.png" class="yun1">
      </div>
    </div>

    <div class="kf" v-if="hasRole('kf')">
      <div class="title-t" style="justify-content: space-between">
        <div class="biaoti" @click="kfShow = !kfShow">
          <span>客服</span>
          <van-icon :name="kfShow ? 'arrow-down' : 'arrow-up'" style="font-weight: bold;margin-left: 5px" />
        </div>
        <div class="switch-style" style="margin: 0; justify-content: flex-end" v-if="kf != null">
          <span v-if="kf.status == 1">在线</span>
          <span v-else-if="kf.status == 2">离线</span>
          <img style="margin-left: 3px;" @click="kf.status = (kf.status == 1 ? '2' : '1');updateStatus(kf.status,'kf')" :src="'/static/images/196/' + (kf.status == 1 ? 'on' : 'off') + '.png'">
        </div>
      </div>
      <div class="body-t" v-show="kfShow">
        <router-link v-if="$KfAccess.includes('manual')" to="/article/list?type=3">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon1.png">
              </div>
              <span>客服手册</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$KfAccess.includes('order')" to="/kf/order/list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon2.png">
              </div>
              <span>订单</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$KfAccess.includes('order-rate')" to="/kf/order/rate-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon18.png">
              </div>
              <span>订单评价</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$KfAccess.includes('order-complain')" to="/kf/order/complain-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon19.png">
              </div>
              <span>订单投诉</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasFeature('kf_wage_statistics') && $KfAccess.includes('wages')" to="/kf/wages">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon4.png">
              </div>
              <span>工资</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$KfAccess.includes('continued-apply') && $hasFeature('order_continued_apply')" to="/kf/order/continued-apply">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon13.png">
              </div>
              <span>续单审核</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$KfAccess.includes('user-manage')" to="/kf/user/user-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon17.png">
              </div>
              <span>用户管理</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>

        <img src="/static/images/196/sku-love.png" class="sku-love2">
        <img src="/static/images/196/yun.png" class="yun2">

      </div>
    </div>

    <div class="leader" v-if="hasRole('leader')">
      <div class="title-t" style="justify-content: space-between">
        <div class="biaoti" @click="leaderShow = !leaderShow">
          <span>组长</span>
          <van-icon :name="leaderShow ? 'arrow-down' : 'arrow-up'" style="font-weight: bold;margin-left: 5px" />
        </div>
        <div class="switch-style" style="margin: 0; justify-content: flex-end" v-if="leader != null">
          <span v-if="leader.status == 1">在线</span>
          <span v-else-if="leader.status == 2">离线</span>
          <img style="margin-left: 3px" @click="leader.status = (leader.status == 1 ? '2' : '1');updateStatus(leader.status,'leader')" :src="'/static/images/196/' + (leader.status == 1 ? 'on' : 'off') + '.png'">
        </div>
      </div>
      <div class="body-t" v-show="leaderShow">
        <router-link v-if="$LeaderAccess.includes('manual')" to="/article/list?type=4">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon1.png">
              </div>
              <span>组长手册</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('order')" to="/leader/order/list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon2.png">
              </div>
              <span>订单</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('order-rate')" to="/leader/order/rate-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon18.png">
              </div>
              <span>订单评价</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('order-complain')" to="/leader/order/complain-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon19.png">
              </div>
              <span>订单投诉</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('clerk-apply-list')" to="/leader/clerk-apply-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon16.png">
              </div>
              <span>新店员申请</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('clerk-check-list')" to="/leader/clerk-check/clerk-check-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon11.png">
              </div>
              <span>店员资料审核</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if=" $hasFeature('leader_wage_statistics') && $LeaderAccess.includes('wages')" to="/leader/wages">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon4.png">
              </div>
              <span>工资</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('continued-apply') && $hasFeature('order_continued_apply')" to="/leader/continued-apply">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon13.png">
              </div>
              <span>续单审核</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('clerk-manage')" to="/leader/clerk-manage">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon14.png">
              </div>
              <span>店员管理</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$LeaderAccess.includes('clerk-performance')" to="/leader/clerk-performance">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon15.png">
              </div>
              <span>店员业绩</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <img src="/static/images/196/sku-love.png" class="sku-love2">
        <img src="/static/images/196/yun.png" class="yun2">

      </div>
    </div>

    <div class="admin" v-if="hasRole('admin')">
      <div class="title-t">
        <div class="biaoti" @click="adminShow = !adminShow">
          <span>管理员</span>
          <van-icon :name="adminShow ? 'arrow-down' : 'arrow-up'" style="font-weight: bold;margin-left: 5px" />
        </div>
      </div>
      <div class="body-t" v-show="adminShow">
        <router-link v-if="$hasFeature(['clerk_group','leader_wage_statistics']) &&( $hasRole('super_admin') || $AdminAccess.includes('leader-wages'))" to="/admin/leader-wages">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon4.png">
              </div>
              <span>组长工资</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasFeature('kf_wage_statistics') && ($hasRole('super_admin') || $AdminAccess.includes('kf-wages'))" to="/admin/kf-wages">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon4.png">
              </div>
              <span>客服工资</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('check-list')" to="/admin/check-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon11.png">
              </div>
              <span>店员资料审核</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasFeature('post_list') && ( $hasRole('super_admin') || $AdminAccess.includes('post-list'))" to="/admin/post-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon12.png" style="height: 70%">
              </div>
              <span>视频管理</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if=" ($hasRole('super_admin') || $AdminAccess.includes('continued-apply')) && $hasFeature('order_continued_apply')" to="/admin/order/continued-apply">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon13.png">
              </div>
              <span>续单审核</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-manage')" to="/admin/clerk-manage">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon14.png">
              </div>
              <span>店员管理</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('order')" to="/admin/order/list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon2.png">
              </div>
              <span>订单</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('order-rate')" to="/admin/order/rate-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon18.png">
              </div>
              <span>订单评价</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('order-complain')" to="/admin/order/complain-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon19.png">
              </div>
              <span>订单投诉</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-performance')" to="/admin/clerk-performance">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon15.png">
              </div>
              <span>店员业绩</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$AdminAccess.includes('clerk-apply')" to="/admin/clerk-apply-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon16.png">
              </div>
              <span>新店员申请</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') || $AdminAccess.includes('user-manage')" to="/admin/user/user-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon17.png">
              </div>
              <span>用户管理</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <router-link v-if="$hasRole('super_admin') && $hasFeature('tech_support_visitor')" to="/admin/tech-support-visitor-list">
          <div class="box-t">
            <div class="left-t">
              <div class="left-img">
                <img src="/static/images/196/icon17.png">
              </div>
              <span>开店咨询</span>
            </div>
            <van-icon name="arrow" color="#BEBEBE" style="margin-right: 12px;font-size: 16px" />
          </div>
        </router-link>
        <img src="/static/images/196/sku-love.png" class="sku-love3">
        <img src="/static/images/196/yun.png" class="yun2 ">

      </div>
    </div>



<!--    <van-cell-group v-if="hasRole('clerk')">-->
<!--      <div slot="title" style="position: relative;">-->
<!--        <div class="flex align-center justify-between">-->
<!--          <span>店员</span>-->
<!--          <div v-if="clerk != null" class="flex align-center">-->
<!--            <template v-if="$hasFeature('auto_online')">-->
<!--              <span v-if="clerkIsAutoOnline" style="color:var(&#45;&#45;primary-color);">自动在线</span>-->
<!--              <span v-else-if="!clerkIsAutoOnline" class="text-gray">手动在线</span>-->
<!--              <van-switch v-model="clerkIsAutoOnline" active-color="var(&#45;&#45;primary-color)"-->
<!--                          class="margin-left-sm margin-right-sm"-->
<!--                          inactive-color="var(&#45;&#45;grey)"-->
<!--                          size="24" @input="(input)=>updateClerkIsAutoOnline(input)"/>-->
<!--            </template>-->
<!--            <span v-if="clerk.status == 1" style="color:var(&#45;&#45;primary-color);">在线</span>-->
<!--            <span v-else-if="clerk.status == 2" class="text-gray">离线</span>-->
<!--            <van-switch :active-value="1" :inactive-value="2" :loading="updateClerkStatusLoading" :value="clerk.status"-->
<!--                        active-color="var(&#45;&#45;primary-color)" class="margin-left-sm" inactive-color="var(&#45;&#45;grey)"-->
<!--                        size="24"-->
<!--                        @input="(input)=>updateStatus(input,'clerk')"/>-->

<!--          </div>-->
<!--        </div>-->
<!--        <div v-if=" $ClerkPermission.modifiableClerkAttr.includes('randomOrderSwitch')"-->
<!--             class="flex justify-end align-center margin-top-sm">-->
<!--          <span :style="{color: clerk && clerk.randomOrderSwitch?'var(&#45;&#45;primary-color)':'gray'}" class="flex align-center">-->
<!--            <question-mark class="margin-right-xs" msg="在线且随机单开启时，才会接收到随机单通知"/>-->
<!--            随机单-->
<!--          </span>-->
<!--          <van-switch :value="clerk && clerk.randomOrderSwitch" active-color="var(&#45;&#45;primary-color)" class="margin-left-sm" inactive-color="var(&#45;&#45;grey)"-->
<!--                      size="24" @input="(input)=>updateRandomOrderSwitch(input)"/>-->

<!--        </div>-->
<!--      </div>-->
<!--      <div v-if="itemSwitchList.length > 0" class="item-switch">-->
<!--        <van-row type="flex">-->
<!--          <van-col v-for="(switchItem, index) of itemSwitchList" :key="index" class="switch-wrap" span="6"-->
<!--                   style="padding: 2px 0">-->
<!--            <van-switch :value="clerkItemSwitchIds.indexOf(switchItem.id) != -1" active-color="var(&#45;&#45;primary-color)"-->
<!--                        inactive-color="var(&#45;&#45;grey)" size="18" @change="updateItemSwitch(switchItem.id)"/>-->
<!--            <div class="item-name">{{ switchItem.name }}</div>-->
<!--          </van-col>-->
<!--        </van-row>-->
<!--      </div>-->

<!--      <van-row class="grid">-->
<!--        <van-col v-if="$ClerkAccess.includes('manual')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/article/list?type=2">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="description" size="30px"/>-->
<!--            <div class="text">店员手册</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$ClerkAccess.includes('order')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/order/list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="orders-o" size="30px"/>-->
<!--            <div class="text">订单</div>-->
<!--          </router-link>-->
<!--        </van-col>-->

<!--        <van-col v-if="$ClerkAccess.includes('random')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/random">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="orders-o" size="30px"/>-->
<!--            <div class="text">抢单大厅</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('out_order') && $ClerkAccess.includes('out-order')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/order/out-order-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="orders-o" size="30px"/>-->
<!--            <div class="text">外部订单</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$ClerkAccess.includes('wages')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/wages">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="balance-o" size="30px"/>-->
<!--            <div class="text">工资</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="($hasFeature('clerk_ranking') || $store.state.shop.version === 'combination') && $ClerkAccess.includes('ranking-list')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/ranking-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="chart-trending-o" size="30px"/>-->
<!--            <div class="text">我的排名</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$ClerkAccess.includes('info')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/info">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="manager-o" size="30px"/>-->
<!--            <div class="text">我的资料</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$ClerkAccess.includes('grade')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/grade">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="label-o" size="30px"/>-->
<!--            <div class="text">我的等级</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$ClerkAccess.includes('reward-log')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/reward-log">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="point-gift-o" size="30px"/>-->
<!--            <div class="text">打赏动态</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        &lt;!&ndash;    开放动态广场    &ndash;&gt;-->
<!--        <van-col v-if="$hasFeature('post_list') && $ClerkAccess.includes('post-list')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/post/list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="chat-o" size="30px"/>-->
<!--            <div class="text">发布动态</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('auto_online') && $ClerkAccess.includes('auto-online')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/auto/online">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="underway-o" size="30px"/>-->
<!--            <div class="text">自动在线</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$ClerkAccess.includes('clerk-houtai')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/clerk-houtai">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="manager-o" size="30px"/>-->
<!--            <div class="text">店员中心</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('gift_wall') && $ClerkAccess.includes('gift')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/gift">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="send-gift-o" size="30px"/>-->
<!--            <div class="text">我的礼物</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col   span="8">-->
<!--          <router-link v-if="$ClerkAccess.includes('my-performance')" class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/performance">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="bar-chart-o" size="30px"/>-->
<!--            <div class="text">我的业绩</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col   span="8">-->
<!--          <router-link v-if="$hasFeature('clerk_item_price') && $ClerkAccess.includes('item-price')" class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/item-price">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="bill-o" size="30px"/>-->
<!--            <div class="text">服务价格</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--      </van-row>-->
<!--    </van-cell-group>-->

<!--    <van-cell-group v-if="hasRole('kf')" title="客服">-->
<!--      <div slot="title" style="position: relative;">客服-->
<!--        <div v-if="kf != null" class="clerk-status">-->
<!--          <span v-if="kf.status == 1" style="color: var(&#45;&#45;primary-color)">在线</span>-->
<!--          <span v-else-if="kf.status == 2" class="text-gray">离线</span>-->
<!--          <van-switch :active-value="1" :inactive-value="2" :loading="updateKfStatusLoading" :value="kf.status"-->
<!--                      active-color="var(&#45;&#45;primary-color)" class="margin-left-sm" inactive-color="var(&#45;&#45;grey)" size="24"-->
<!--                      @input="(input)=>{updateStatus(input,'kf')}"/>-->
<!--        </div>-->
<!--      </div>-->
<!--      <van-row class="grid">-->
<!--        <van-col v-if="$KfAccess.includes('manual')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/article/list?type=3">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="description" size="30px"/>-->
<!--            <div class="text">客服手册</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$KfAccess.includes('order')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/order/list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="orders-o" size="30px"/>-->
<!--            <div class="text">订单</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('kf_wage_statistics') && $KfAccess.includes('wages')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/wages">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="balance-o" size="30px"/>-->
<!--            <div class="text">工资</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('order_entry_list') && $KfAccess.includes('order-entry')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/order-entry">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="records" size="30px"/>-->
<!--            <div class="text">订单录入</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('first_order') && $KfAccess.includes('first-order')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/first-order">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="records" size="30px"/>-->
<!--            <div class="text">首单体验</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$KfAccess.includes('continued-apply') && $hasFeature('order_continued_apply')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/order/continued-apply">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="completed" size="30px"/>-->
<!--            <div class="text">续单审核</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('out_order') && $KfAccess.includes('out-order')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/order/out-order-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="orders-o" size="30px"/>-->
<!--            <div class="text">外部订单</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$KfAccess.includes('user-manage')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/kf/user/user-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="manager-o" size="30px"/>-->
<!--            <div class="text">用户管理</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--      </van-row>-->
<!--    </van-cell-group>-->

<!--    <van-cell-group v-if="hasRole('leader')" title="组长">-->
<!--      <div slot="title" style="position: relative;">组长-->
<!--        <div v-if="leader != null" class="clerk-status">-->
<!--          <span v-if="leader.status == 1" style="color: var(&#45;&#45;primary-color)">在线</span>-->
<!--          <span v-else-if="leader.status == 2" class="text-gray">离线</span>-->
<!--          <van-switch :active-value="1" :inactive-value="2" :loading="updateLeaderStatusLoading" :value="leader.status"-->
<!--                      active-color="var(&#45;&#45;primary-color)" class="margin-left-sm" inactive-color="var(&#45;&#45;grey)" size="24"-->
<!--                      @input="(input)=>{updateStatus(input,'leader')}"/>-->
<!--        </div>-->
<!--      </div>-->
<!--      <van-row class="grid">-->
<!--        <van-col v-if="$LeaderAccess.includes('manual')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/article/list?type=4">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="description" size="30px"/>-->
<!--            <div class="text">组长手册</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if=" $hasFeature('leader_wage_statistics') && $LeaderAccess.includes('wages')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/wages">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="balance-o" size="30px"/>-->
<!--            <div class="text">工资</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$LeaderAccess.includes('clerk-apply-list')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/clerk-apply-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="friends-o" size="30px"/>-->
<!--            <div class="text">新店员申请</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$LeaderAccess.includes('clerk-check-list')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/clerk-check/clerk-check-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="friends-o" size="30px"/>-->
<!--            <div class="text">店员资料审核</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('post_list') && $LeaderAccess.includes('clerk-post-check-list')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/clerk-post-check-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="chat-o" size="30px"/>-->
<!--            <div class="text">动态审核</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$LeaderAccess.includes('continued-apply') && $hasFeature('order_continued_apply')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/continued-apply">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="completed" size="30px"/>-->
<!--            <div class="text">续单审核</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$LeaderAccess.includes('clerk-manage')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/clerk-manage">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="manager-o" size="30px"/>-->
<!--            <div class="text">店员管理</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$LeaderAccess.includes('clerk-performance')"  span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/clerk/clerk-performance">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="bar-chart-o" size="30px"/>-->
<!--            <div class="text">店员业绩</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--      </van-row>-->
<!--    </van-cell-group>-->

<!--    <van-cell-group v-if="hasRole('admin')" title="管理员">-->
<!--      <van-row class="grid">-->
<!--        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('order')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/order/list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="orders-o" size="30px"/>-->
<!--            <div class="text">订单</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature(['clerk_group','leader_wage_statistics']) &&( $hasRole('super_admin') || $AdminAccess.includes('leader-wages'))" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/leader-wages">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="balance-o" size="30px"/>-->
<!--            <div class="text">组长工资</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('kf_wage_statistics') && ($hasRole('super_admin') || $AdminAccess.includes('kf-wages'))" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/kf-wages">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="balance-o" size="30px"/>-->
<!--            <div class="text">客服工资</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-performance')"  span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/clerk/clerk-performance">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="bar-chart-o" size="30px"/>-->
<!--            <div class="text">店员业绩</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('clerk-manage')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/clerk-manage">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="manager-o" size="30px"/>-->
<!--            <div class="text">店员管理</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasFeature('post_list') && ( $hasRole('super_admin') || $AdminAccess.includes('post-list'))" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/post-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="chat-o" size="30px"/>-->
<!--            <div class="text">动态管理</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('check-list')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/clerk/check-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="friends-o" size="30px"/>-->
<!--            <div class="text">店员资料审核</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if=" ($hasRole('super_admin') || $AdminAccess.includes('continued-apply')) && $hasFeature('order_continued_apply')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/order/continued-apply">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="completed" size="30px"/>-->
<!--            <div class="text">续单审核</div>-->
<!--          </router-link>-->
<!--        </van-col>-->

<!--        <van-col v-if="$store.state.shop.platform == $store.state.ShopPlatformEnum.DINGTALK.value" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/leader/get_userid">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="more-o" size="30px"/>-->
<!--            <div class="text">获取用户ID</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$AdminAccess.includes('clerk-apply')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/clerk-apply-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="friends-o" size="30px"/>-->
<!--            <div class="text">新店员申请</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--        <van-col v-if="$hasRole('super_admin') || $AdminAccess.includes('user-manage')" span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/admin/user/user-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="manager-o" size="30px"/>-->
<!--            <div class="text">用户管理</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--      </van-row>-->
<!--    </van-cell-group>-->

    <van-row v-if="clerkWarning" type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8"  :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem" />
      </van-col>
      <van-col span="24" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <div>您已被下架，没有权限访问</div>
      </van-col>
    </van-row>

    <van-row v-if="isResigned" type="flex" justify="center" align="center" :style="'margin-top:10rem;'">
      <van-col span="8"  :style="'text-align:center'">
        <van-icon name="warning" color="lightblue" size="8rem" />
      </van-col>
      <van-col span="24" align="center" :style="'margin-top:10px;font-weight:bold;text-align:center'">
        <div>您已离职，需要复职请联系店铺管理员。</div>
      </van-col>
    </van-row>

    <div class="text-center padding-tb">
      <router-link to="/clear-storage">清理缓存</router-link>
    </div>

    <foot v-if="$store.state.shop.id != 11 && $store.state.shop.id != 13 && $store.state.shop.id != 34 && $store.state.shop.id != 75
        && $store.state.shop.id != 127 && $store.state.shop.id != 6"></foot>

    <template v-if="$store.state.shop.id == 127">
      <div>
        <div class="text-center padding-tb-lg">
          <div style="color: #ccc" @click="showOpenShop=true">我要开店</div>
        </div>
      </div>

      <van-dialog v-model="showOpenShop">
        <div class="flex justify-center">
          <img alt="qrcode" src="/static/images/127/qrcode.png" style="width: 300px;">
        </div>
      </van-dialog>
    </template>

  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Col, Dialog, Icon, Row, Switch, Toast} from 'vant';
import {
  getClerk,
  getItemSwitchList,
  updateClerkAutoOnlineStatus,
  updateClerkStatus,
  updateItemSwitch,
  getStatisticsInfo,
  updateRandomOrderSwitch
} from '@/api/clerk/clerk'
import foot from '@/views/foot';
import {getKf, updateKfStatus} from "@/api/kf/kf";
import {getLeader, updateLeaderStatus} from "@/api/leader/leader";
import {getClerkSetting} from "@/api/shop";
import QuestionMark from "@/views/question-mark";
import announcement from "@/views/announcement";
import balanceWithdraw from "@/components/common/balance-withdraw";

Vue.use(Row)
    .use(Col)
    .use(Icon)
    .use(CellGroup)
    .use(Cell)
    .use(Switch)
    .use(Dialog)
    .use(Toast)

export default {
  name: 'index',
  components: {
    announcement,
    QuestionMark,
    balanceWithdraw,
    foot
  },
  data() {
    return {
      clerkShow: true,
      kfShow: true,
      leaderShow: true,
      adminShow: true,
      showOpenShop: false,
      roles: null,
      clerkIsAutoOnline: false,
      clerk: null,
      kf: null,
      leader: null,
      updateClerkStatusLoading: false,
      updateKfStatusLoading: false,
      updateLeaderStatusLoading: false,
      itemSwitchList: [],
      clerkItemSwitchIds: [],
      allowRandomOrderSwitch: null,
      clerkWarning: false,
      isResigned: false,
      removeClerkRole:null,
      statistics: {
        today: null,
        yesterday: null,
        thisWeek: null,
        lastWeek: null,
        total: null,
      }
    }
  },
  methods: {
    getStatisticsInfo(){
      Toast.loading({
        mask: true,
        message: '请稍候'
      })

      getStatisticsInfo().then(res => {
        Toast.clear()
        this.statistics = res.data
      })
    },
    hasRole(role) {
      if (this.roles == null) {
        return false;
      }
      return this.roles.indexOf(role) != -1;
    },
    verifyRole(){
      if (this.roles == null || this.roles.length == 0) {
        if (this.removeClerkRole) {
          this.clerkWarning = true
        } else {
          this.$router.replace('/noAccount')
        }
      } else if (this.roles.length == 1 && this.hasRole('user')) {
        // 这里是限制只是店员角色 但是已经离职了 就显示离职提示
        if (this.$store.state.isResigned) {
          this.isResigned = true
        } else if (this.removeClerkRole) {
          this.clerkWarning = true
        } else {
          this.$router.replace('/noAccount')
        }
      }
    },
    loadData() {
      this.roles = this.$store.state.roles
      this.removeClerkRole = this.$store.state.removeClerkRole
      this.verifyRole()
      if (this.hasRole('clerk')) {
        this.loadClerkInfo()
      }
      if (this.hasRole('kf')) {
        this.loadKfInfo()
      }
      if (this.hasRole('leader')) {
        this.loadLeaderInfo()
      }
    },
    loadClerkInfo() {
      Promise.all([getClerk(), getItemSwitchList(), getClerkSetting()]).then((results) => {

        const data1 = results[0].data
        const data2 = results[1].data
        const data3 = results[2].data
        if (data1.code != 0) {
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '信息失败',
            desc: data1.msg
          })
        }
        if (data2.code != 0) {
          Dialog.alert({
            title: '加载服务失败',
            message: data2.msg
          })
        }
        if (data3.code != 0) {
          Dialog.alert({
            title: '加载店铺设置失败',
            message: data3.msg
          })
        }

        this.clerk = data1.clerk
        this.clerkIsAutoOnline = this.clerk.isAutoOnline
        this.itemSwitchList = data2.itemSwitchList
        this.clerkItemSwitchIds = data2.clerkItemSwitchIds
        this.allowRandomOrderSwitch = data3.setting.allowRandomOrderSwitch
      }).catch((e) => {
        Dialog.alert({
          title: '加载数据失败',
          message: JSON.stringify(e)
        })
      })
    },
    loadKfInfo() {
      getKf().then(res => {
        const data = res.data;
        if (data.code != 0) {
          Dialog.alert({
            title: '加载客服信息失败',
            desc: data.msg
          })
        }
        this.kf = data.kf
      })
    },
    loadLeaderInfo() {
      getLeader().then(res => {
        const data = res.data;
        if (data.code !== 0) {
          Dialog.alert({
            title: '加载组长信息失败',
            desc: data.msg
          })
        }
        this.leader = data.leader
      })
    },
    updateClerkIsAutoOnline() {
      updateClerkAutoOnlineStatus(this.clerkIsAutoOnline).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast("修改成功")
        } else {
          this.clerkIsAutoOnline = false
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
    updateStatus(status, role) {
      let updateAutoOnline = false;
      switch (role) {
        case 'clerk':
          this.updateClerkStatusLoading = true
          if (this.$hasFeature('auto_online')) {
            updateAutoOnline = true;
          }
          updateClerkStatus(status, updateAutoOnline).then(res => {
            this.updateClerkStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              Toast('修改状态成功')
              this.loadClerkInfo()
            } else {
              // this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
            // this.loadData()
          });
          break;
        case 'kf':
          this.updateKfStatusLoading = true;
          updateKfStatus(status).then(res => {
            this.updateKfStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.kf.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
        case 'leader':
          this.updateLeaderStatusLoading = true;
          updateLeaderStatus(status).then(res => {
            this.updateLeaderStatusLoading = false
            const data = res.data;
            if (data.code == 0) {
              this.leader.status = status
              Toast('修改状态成功')
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改状态失败',
                message: data.msg
              })
            }
          });
          break;
      }

    },
    updateRandomOrderSwitch(randomOrderSwitch) {
      updateRandomOrderSwitch(randomOrderSwitch).then(res => {
        const data = res.data;
        if (data.code == 0) {
          Toast('修改成功')
          this.loadData()
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          }).then(() => {
            // this.loadData()
          })
        }
      })
    },
    updateItemSwitch(switchId) {
      let switchIds = [].concat(this.clerkItemSwitchIds)
      if (switchIds.indexOf(switchId) != -1) {
        switchIds.splice(switchIds.indexOf(switchId), 1)
      } else {
        switchIds.push(switchId)
      }

      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      updateItemSwitch(
          JSON.stringify(switchIds),
          switchId
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.clerkItemSwitchIds = switchIds
          Toast('修改成功')
        } else {
          // this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    }
  },
  // activated() {
  //   this.loadData()
  // },

  mounted() {
    this.loadData()
    this.getStatisticsInfo()
  }
}
</script>

<style lang="less" scoped>
.body{
  position: relative;
  z-index: 0;
  &::after {
    content: "";
    background: linear-gradient(180deg, #8DC5FF 0%, #C5E0FD 26%, #F1F3F5 63%, #F4F4F4 100%);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -2
  }
}

/deep/.header-custom{
  background: none;
}

.clerk{
  padding: 15px;
  .clerk-head{
    padding: 12px 18px;
    position: relative;
    margin-bottom: 15px;


    &::after{
      content: '';
      position: absolute;
      inset: 0;
      background: url("/static/images/196/bg.png") no-repeat;
      background-size: 100% 100%;
      z-index: -1;
    }

    .clerk-img{
      margin-right: 10px;
      img{
        border-radius: 50%;
        width: 64px;
        height: 64px;
        object-fit: cover;
      }
    }
    .clerk-other{
      flex: 1;
      .box1{
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        .name{
          color: #333333;
          font-size: 13px;
          font-weight: 500;
        }
        .grade{
          height: 17px;
          display: block;
          margin-left: 9px;
        }
      }

      .sex-age{
        background: #FC8E6E;
        border-radius: 8px;
        display: inline-block;
        padding: 0 7px;
        color: #fff;
      }
    }

    .box2{
      margin: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
  .profit{
    border-radius: 10px;
    margin-bottom: 10px;
    position: relative;

    .title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #2284EF;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;

      span{
      }
      img{
        height: 30px;
        margin-bottom: 5px;
      }
    }
    .profit-body{
      border-radius: 10px;
      color: #fff;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .box-left{
        display: flex;
        flex-flow: column;
        font-size: 11px;
        .money{
          font-size: 29px;
          font-weight: bold;
          margin-bottom: 5px;
        }
      }
      .box-right{
        font-size: 11px;
      }
    }

    .xx-icon{
      width: 128px;
      position: absolute;
      top: -14px;
      left: 0px;
    }
  }
}

.kf{
  padding: 0 15px 15px 15px;
}
.leader{
  padding: 0 15px 15px 15px;
}
.admin{
  padding: 0 15px 15px 15px;
}

.switch-style{
  display: inline-flex;
  align-items: center;
  margin-bottom: 5px;
  width: 33%;

  span{
    white-space: nowrap;
    color: #333;
    font-size: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img{
    height: 15px;
    width: 36px;
    display: block;
    margin-right: 3px;
  }
}

.title-t{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  padding-left: 4px;

  .biaoti{
    display: flex;
    align-items: center;
    color: #333;
    font-size: 15px;
  }
}
.body-t{
  background: linear-gradient(180deg, rgba(178, 213, 255, .63) 0%, rgba(210, 224, 253, .63) 100%);
  box-shadow: inset 0px 6px 11px 1px rgba(255,255,255,0.55);
  border: 1px solid #FFFFFF;
  border-radius: 17px;
  overflow: hidden;
  position: relative;
  .box-t{
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px rgba(112, 112, 112, 0.05) solid;
    .left-t{
      display: flex;
      align-items: center;
      .left-img{
        width: 54px;
        height: 24px;
        position: relative;
        img{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          height: 100%;
          display: block;
        }
      }
      span{
        color: #333333;
        font-size: 12px;
      }
    }
  }

  .sku-love1{
    position: absolute;
    top: 90px;
    right: 0px;
    width: 81px;
    height: 92px;
    pointer-events: none;
  }

  .sku-love2{
    position: absolute;
    top: 35px;
    right: 0px;
    width: 81px;
    height: 92px;
    pointer-events: none;
  }

  .sku-love3{
    position: absolute;
    top: 90px;
    right: 0px;
    width: 81px;
    height: 92px;
    pointer-events: none;
  }

  .yun1{
    position: absolute;
    top: 58px;
    left: 19px;
    width: 102px;
    height: 107px;
    pointer-events: none;
  }

  .yun2{
    position: absolute;
    top: 6px;
    left: 19px;
    width: 102px;
    height: 107px;
    pointer-events: none;
  }

}




.grid {
  .item {
    display: block;
    padding: 20px 0;
    text-align: center;

    &:active {
      background: #e5e5e5;
    }

    .icon {

    }

    .text {
      color: #333;
      font-size: 14px;
      margin-top: 6px;
    }
  }
}

.clerk-status {
  position: absolute;
  right: 0;
  bottom: -5px;
  display: flex;
  align-items: center;
}

.item-switch {
  padding: 15px 0;

  .switch-wrap {
    text-align: center;
  }

  .item-name {
    font-size: 10px;
  }
}

</style>
